import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import map from 'lodash/map';
import startCase from 'lodash/startCase';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Select from 'antd/lib/select';

import { bulkUpdateProductsAction, updateProductAction } from 'store/actions/listsActions';
import { EEditType } from 'types/commonEnums';
import { EProductConditions } from 'types/listsTypes';

const { Option } = Select;
const conditions = ['new', 'used'];

interface IProductConditionProps {
  ids: string[],
  isBulk?: boolean,
  onModalClose: () => void,
}

const ProductCondition: FC<IProductConditionProps> = ({ ids, isBulk, onModalClose }) => {
  const dispatch = useDispatch();
  const [productCondition, setProductCondition] = useState<EProductConditions>();

  const handleUpdate = async() => {
    const action = isBulk ? bulkUpdateProductsAction : updateProductAction;

    await dispatch(action({ ids, type: EEditType.Edit, productCondition }));
    onModalClose();
  };

  return (
    <div className="w-96">
      <h2 className="my-4">Change Product{isBulk ? 's' : ''} Condition</h2>
      <Select size="large" className="min-w-full" placeholder="Enter Condition" onChange={setProductCondition}>
        {map(conditions, (condition) => <Option key={condition} value={condition}>{startCase(condition)}</Option>)}
      </Select>
      <Divider />
      <Button
        size="large"
        type="primary"
        disabled={!productCondition}
        className="block ml-auto"
        onClick={handleUpdate}
      >
        Done
      </Button>
    </div>
  );
};

export default ProductCondition;
